import { useEffect, useState } from "react";
import "./AboutUsTheCompany.scss";

import Dash from "../../components/Dash/Dash";

import {
  BannerImage1,
  BannerImage2,
  BannerImage1_mobile,
  BrandImage1,
  BrandImage2,
  BrandImage3,
  BrandImage4,
  BrandImage5,
  BrandImage6,
  BrandImage7,
  BrandImage8,
  BrandImage9,
  BrandImage10,
  BrandImage11,
  BrandImage12,
  BrandImage13,
  BrandImage14,
  BrandImage15,
  BrandImage16,
  BrandImage17,
  BrandImage18,
  BrandImage19,
  BrandImage20,
  BrandImage21,
  BrandImage22,
  BrandImage23,
  BrandImage24,
  BrandImage25,
  BrandImage26,
  BrandImage27,
  BrandImage28,
  BrandImage29,
  BrandImage30,
  LogoImg1,
  LogoImg2,
  LogoImg3,
  LogoImg4,
  LogoImg5,
  OurCompanyImage,
} from "../../images";

//swiper imports
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
  Parallax,
  Mousewheel,
  Controller,
} from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
import { Link } from "react-router-dom";
import Stock from "../../components/StockIndicator/Stock";

Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
  Parallax,
  Mousewheel,
  Controller,
]);

const AboutUsTheCompany = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    var clients_slider_wrapper = new Swiper(
      ".swiper-container.clients_slider_wrapper",
      {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        freeMode: true,
        grabCursor: false,
        allowTouchMove: false,
        slidesPerView: 7,
        autoplay: {
          delay: 1,
          disableOnInteraction: true,
        },
        speed: 2500,
        navigation: {
          nextEl: ".clients_slider_wrapper .right_arrow",
          prevEl: ".clients_slider_wrapper .left_arrow",
        },
        spaceBetween: 40,
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
          },
          1023: {
            slidesPerView: 5.5,
          },
        },
      }
    );
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/about-us/the-company"
        metaTitle="About Us - Our Company |Sanathan Textiles"
        metaDesc="Learn about Sanathan Textiles, a distinguished yarn manufacturing company in India. With a rich legacy and innovative approach, we are key players in the textiles industry. Explore now!"
      />

      <section className="aboutus_the_company_v2">
        <div className="wrapper">
          <div className="breadcrumb_styles">About us {">"} Our Company</div>
          <div className="grid">
            <div className="left_section">
              <h1 className="hollow_title">Our Company</h1>
              <div className="dash_wrapper">
                <Dash />
              </div>
              <div className="statement">Purpose Statement</div>
              <div className="desc">
                “To be a trusted global leader, shaping the world of fashion and
                performance textiles, through innovative and sustainable
                solutions”
              </div>
            </div>
            <div className="right_section">
              <img src={OurCompanyImage} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="about_sanathan">
        <div className="wrapper">
          <h2 className="hollow_title">About Sanathan Textiles</h2>
          <div className="grid">
            <p className="about_text">
              Sanathan Textiles is a leading polyester yarn manufacturer and
              global supplier of cotton, polyester, and technical textile yarns.
              With three business verticals, we offer a wide product range used
              across industries and applications, catering to 2,588 customers
              between April 1, 2020 and December 31, 2023 for end-products such
              as apparel, home furnishings, luggage, ropes, seatbelts,
              upholstery, sportswear, innerwear, umbrellas, PPE, and pipes. Our
              in-house testing facility, advanced equipment, and digitized
              processes ensure high standards of quality, operational
              efficiency, and continuous improvement. We continue to invest in
              modernizing technology to enhance performance and optimize
              production costs. <br /> <br /> Our Product Innovation &
              Development team focuses on value-added and customized
              made-to-order yarns, strengthening long-term customer
              relationships and contributing significantly to high-margin
              revenue. The ability to tailor products to unique specifications
              gives us a competitive edge in both domestic and international
              markets. Our growth is powered by the deep expertise of our
              promoters and senior management, who collectively bring ~160 years
              of textile experience and have been instrumental in continuously
              expanding our product portfolio, customer base, and market
              presence.
            </p>
            <div className="stock_wrapper">
              <Stock />
            </div>
          </div>
        </div>
      </section>

      <section className="clients_slider">
        <div className="clients_slider_wrapper swiper-container">
          <div className="clients_slider_wrapper_heading_section">
            <div className="left_section">
              <div className="hollow_title">Our Customers</div>
              <h3>we supply to 1150+ customers worldwide</h3>
            </div>
          </div>
          <ul className="swiper-wrapper">
            <li className="swiper-slide">
              <img src={BrandImage1} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage2} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage3} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage4} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage5} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage6} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage7} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage8} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage9} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage10} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage11} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage12} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage13} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage14} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage15} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage16} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage17} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage18} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage19} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage20} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage21} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage22} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage23} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage24} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage25} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage26} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage27} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage28} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage29} alt="sanathan img" />
            </li>
            <li className="swiper-slide">
              <img src={BrandImage30} alt="sanathan img" />
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default AboutUsTheCompany;
